import { Col, Row, Spin, Table, Tabs, Tooltip, message, Input, Checkbox } from 'antd'
import React, { useEffect, useState } from 'react'
import MainLayout from '../../components/main_layout/MainLayout'
import { useListEssentialQuery } from '../../features/api/adminApi/essential';
import { DeleteOutlined, EditFilled, FilterOutlined } from '@ant-design/icons';
import MasterModal from '../../components/mastermodal/MasterModal';
import { useAddMasterNameMutation, useDeleteMasterNameMutation, useEditMasterNameMutation } from '../../features/api/adminApi/master_api';
import errorMessage from '../../global/errorMessage/ErrorMessage';
import CustomerModal from "../../components/custommodal/CustomerModal";
import { useAddCustomerPositionMutation, useDeleteCustomerPositionMutation, useEditCustomerMutation, useEditCustomerPositionMutation } from '../../features/api/superadminApi/customer_api';
const { Search } = Input;

const SuperAdminMaster = () => {
    const [key, setKey] = useState(1);
    const [editName, setEditName] = useState("");
    const [companyId, setCompanyId] = useState(0);
    const [typeId, setTypeId] = useState(0);
    const [masterType, setMasterType] = useState("");
    const [addButton, setAddButton] = useState("");
    const [popupType, setPopupType] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    
    const {
            data: essentialData, 
            isSuccess, 
            isLoading: essentialLoading,
            isFetching: essentialFetching,
            
        } =  useListEssentialQuery("position")
    
    const [editMasterName, {isLoading: editMasterLoading}] = useEditCustomerPositionMutation()
    const [addMasterName, {isLoading: addMasterLoading}] = useAddCustomerPositionMutation()
    const [deleteMasterName, {isLoading: deleteMasterLoading}] = useDeleteCustomerPositionMutation()

    const handleFinish = (values) => {
        let params = {}
        if(popupType === "Edit"){
            params = {
                formData: values,
                id: typeId
            }
        }
        
        popupType === "Add" ? 
            addMasterName(values)
                .unwrap()
                .then((res) => {
                    message.success(res.message);
                    setIsModalOpen(false)
                })
                .catch((err) => {
                    errorMessage(err?.data?.error)
                    setIsModalOpen(false)
                })

        : popupType === "Edit" ?
               
            editMasterName(params)
            .unwrap()
                .then((res) => {
                    message.success(res.message);
                    setIsModalOpen(false)
                })
                .catch((err) => {
                    errorMessage(err?.data?.error)
                    setIsModalOpen(false)
                })

        : deleteMasterName(typeId)
            .unwrap()
            .then((res) => {
                message.success(res.message);
                setIsDeleteModalOpen(false)
            })
            .catch((err) => {
                errorMessage(err?.data?.error)
                setIsDeleteModalOpen(false)
            })
        
    }

    const breadcrumbs = [
        {
            title: "Dashboard",
            href: "/super-admin/dashboard",
        },
        {
            title: "SuperAdmin Master",
            // href: location.pathname,
        },
    ]

    const columns = [
        {
			title: 'Serial No',
            dataIndex: 'index',
            key: 'index',
            render: (_, __, index) => index + 1,
		},
        {
			title: "Name",
			dataIndex: key === 1 ? "position_name" :  null,
		},
        {
			title: "Action",
			align: "center",
			render: (_, record) => {
				return (
					<>
						<Row gutter={15} justify={"center"}>
							<Col>
								<Tooltip title="Edit" className={""}>
									<EditFilled onClick={() => {
                                                                setIsModalOpen(true)
                                                                setCompanyId(record?.company_id)
                                                                setTypeId(record?.id)
                                                                setEditName(record)
                                                                setPopupType("Edit")
                                                            }}/>
								</Tooltip>
							</Col>
							<Col>
								<Tooltip
									title="Delete"
									style={{ paddingTop: "10px" }}
									className={""}>
									<DeleteOutlined onClick={() => {
                                                                setIsDeleteModalOpen(true)
                                                                setTypeId(record?.id)
                                                                setPopupType("Delete")
                                                            }}/>
								</Tooltip>
							</Col>
						</Row>
					</>
				);
			},
		},
    ]
    
    useEffect(() => {
        if(key === 1){
            setMasterType("position_name")
            setAddButton("Position")
        }
    }, [key])

  return (
    <Spin spinning={false}>
        <MainLayout title={"Master"}
            breadcrumbs={breadcrumbs}
            upload={[]} 
            button={[{
                label: `Add ${addButton}`,
                func: () => {
                    setIsModalOpen(true)
                    setPopupType("Add")
                },
            },]} 
            banner={false}>
            <Row gutter={[30,30]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Tabs className='master-tab'
                        defaultActiveKey={1}
                        activeKey={key}
                        onChange={(key) => {
                            setKey(key);
                        }}
                        tabPosition={"top"}
                        tabBarGutter={100}
                        type={"line"}
                        items={[
                            {
                                label: "Positions",
                                key: 1,
                            },
                            
                        ]}>
                    </Tabs>
                    
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
					<Spin spinning={essentialFetching}>
                        {isSuccess && (
                            <>
                                {key === 1 ? (
                                    <div>
                                        <div className="outlet_table">
                                            <Table
                                                size="small"
                                                rowKey={(record)=> record.id}
                                                columns={columns}
                                                loading={essentialLoading}
                                                dataSource={essentialData?.data?.positions}
                                                // pagination={{
                                                //     total: total ?? 0,
                                                //     defaultPageSize: 10,
                                                //     pageSizeOptions: [10, 25, 50, 100, 500],
                                                //     showSizeChanger: true,
                                                //     onChange: (page, pageSize) => {
                                                //         const setting = {
                                                //             ...searchParams,
                                                //             page,
                                                //             per_page: pageSize,
                                                //         }
                                                //         setSearchParams(setting)
                                                //     },
                                                // }}
                                                scroll={{
                                                    x: 700,
                                                    y: 400,
                                                }}
                                            />
                                        </div>
                                    </div>

                                ) : null}
                            </>
                        )}
					</Spin>
				</Col>
            </Row>
            {isModalOpen ? (
                <MasterModal 
                    initialValues={editName}
                    title={popupType+" "+addButton}
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    handleFinish = {handleFinish}
                    loading={
                                popupType === "Add" 
                                ? addMasterLoading 
                                : editMasterLoading 
                            }
                    masterType={masterType}
                    popupType={popupType}
                    />
			    ) : null
            }
            {isDeleteModalOpen ? (
					<CustomerModal
						handleFinish={(values) => handleFinish(values)}
						title={popupType+" "+addButton}
						setIsModalOpen={setIsDeleteModalOpen}
						isModalOpen={isDeleteModalOpen }
						loading={deleteMasterLoading}>
						Are you sure to delete?
					</CustomerModal>
				) : null
            }
        </MainLayout>
    </Spin>
  )
}

export default SuperAdminMaster